import { NgModule } from '@angular/core';
import { QRCodeComponent } from './components';
var QRCodeModule = /** @class */ (function () {
    function QRCodeModule() {
    }
    QRCodeModule.decorators = [
        { type: NgModule, args: [{
                    providers: [],
                    declarations: [
                        QRCodeComponent,
                    ],
                    exports: [
                        QRCodeComponent,
                    ]
                },] },
    ];
    return QRCodeModule;
}());
export { QRCodeModule };
//# sourceMappingURL=angularx-qrcode.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularx-qrcode/dist/angularx-qrcode.module.js
// module id = 219
// module chunks = 0